export const LINE_THICKNESS_MIN = 5;
export const LINE_THICKNESS_MAX = 25;